import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { RenderField, Validators } from '../../Layout/Form/Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import * as UserModule from 'Modules/UserModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {compose} from 'redux';

type ConnectedProps = {
    userStore: UserModule.Types.UserStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t: Function;
};

const ResetPasswordConfirmForm = (props: InjectedFormProps & ConnectedProps) => {
    const { handleSubmit, pristine, submitting, t, userStore } = props;
    return (
        <form className="form" onSubmit={handleSubmit}>
            {userStore.error.resetConfirmErr && <p className="form_field--error form_field--error_msg">{t(`errors:${userStore.error.resetConfirmErr.errorSubcode}`)}</p>}
            {userStore.success.resetConfirmSuccess && <p className="form_field--success form_field--success_msg">{t('resetConfirmSuccess')}</p>}
            <Field name="password" component={RenderField} type="password" placeholder={t('password')} label={t('password')} validate={[Validators.required,Validators.password]} />
            <p>
                {t('accountPresent')} <Link to="/">{t('logIn')}</Link>
            </p>
            <button disabled={submitting || pristine} className="btn btn--blue" type="submit">
                {t('send')}
            </button>
        </form>
    );
};

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore,
        userStore: state.userStore
    };
}


export default compose(
    connect(mapStateToProps),
    withTranslation (['forms', 'errors']),
    reduxForm({
        form: 'resetPasswordConfirm'
    })
)(ResetPasswordConfirmForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/UserSigning/Forms/_ResetPasswordConfirmForm.tsx